import Splide from "@splidejs/splide";

function initSplides() {
    const productGallery = document.querySelector<HTMLElement>('.product-gallery');
    const actieGallery = document.querySelector<HTMLElement>('.actie-splide');

    if (productGallery) {
        initGallery(productGallery);
    }

    if (actieGallery) {
        const actieSplide = new Splide(actieGallery, {
            type: 'loop',
            rewind: true,
            pagination: true,
            arrows: true,
            autoplay: true,
            interval: 5000,
        });

        actieSplide.mount();
    }
}

function initGallery(product_gallery: HTMLElement) {
    const main_splide_element = product_gallery.querySelector<HTMLElement>('#main-carousel');
    const thumbnail_splide_element = product_gallery.querySelector<HTMLElement>('#thumbnail-carousel');

    if (!main_splide_element || !thumbnail_splide_element) return;

    const is_wc_product = product_gallery.classList.contains('woocommerce-product-gallery__wrapper');
    const thumbnails_gap: number = is_wc_product ? 12 : 17;

    const main_splide = new Splide(main_splide_element, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false
    });

    const thumbnails_splide = new Splide(thumbnail_splide_element, {
        gap: thumbnails_gap,
        rewind: true,
        pagination: false,
        isNavigation: true,
        arrows: true,
        perPage: 3,
        perMove: 1,
        arrowPath: 'm39.25 21.75c1-1 1-2.5 0-3.5l-12.5-12.5c-1-1-2.5-1-3.5 0-1 1-1 2.5 0 3.5l8.25 8.25h-29c-1.5 0-2.5 1-2.5 2.5s1 2.5 2.5 2.5h29l-8.25 8.25c-1 1-1 2.5 0 3.5s2.5 1 3.5 0l12.5-12.5z',
    });

    main_splide.mount();
    thumbnails_splide.sync(main_splide);
    thumbnails_splide.mount();
}

if (document.readyState === 'complete') {
    initSplides();
} else {
    window.addEventListener('load', initSplides);
}
